import { AlertTriangle, Info, ArrowRight, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useWarningPopup } from "@/contexts/WarningPopupContext";

const WHATSAPP_LINK = "https://wa.me/5581984555155?text=Olá! Gostaria de agendar um atendimento particular.";

const WarningPopup = () => {
  const { isOpen, close } = useWarningPopup();

  const handleContinue = () => {
    window.open(WHATSAPP_LINK, "_blank", "noopener,noreferrer");
    close();
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className={`fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm transition-opacity duration-200 ${isOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        onClick={close}
      />

      {/* Popup Container */}
      <div className={`fixed inset-0 z-[101] flex items-center justify-center p-4 transition-all duration-300 ${isOpen ? "opacity-100 scale-100 translate-y-0" : "opacity-0 scale-95 translate-y-5 pointer-events-none"}`}>
        <div className="relative w-full max-w-md max-h-[90vh] overflow-y-auto bg-card rounded-2xl shadow-2xl border border-border">
          <button
            onClick={close}
            className="absolute right-3 top-3 sm:right-4 sm:top-4 p-1.5 rounded-full bg-card hover:bg-secondary transition-colors z-10"
            aria-label="Fechar"
          >
            <X className="w-5 h-5 text-muted-foreground" />
          </button>

          <div className="p-5 sm:p-8 md:p-10 text-center space-y-4 sm:space-y-6">
            <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-coral-light flex items-center justify-center mx-auto">
              <AlertTriangle className="w-7 h-7 sm:w-8 sm:h-8 text-coral-dark" />
            </div>

            <div className="space-y-1">
              <span className="text-xs sm:text-sm font-medium text-coral uppercase tracking-wide">Atenção</span>
              <h2 className="font-serif text-xl sm:text-2xl md:text-3xl font-bold text-foreground">Página de Atenção!</h2>
              <p className="text-sm sm:text-base text-muted-foreground">Leia antes de continuar</p>
            </div>

            <div className="bg-coral-light/50 rounded-xl p-4 sm:p-5 space-y-3 sm:space-y-4 text-left">
              <div className="flex items-start gap-2.5 sm:gap-3">
                <Info className="w-4 h-4 sm:w-5 sm:h-5 text-coral-dark flex-shrink-0 mt-0.5" />
                <div className="space-y-0.5 sm:space-y-1">
                  <p className="font-semibold text-foreground text-xs sm:text-sm">Não aceitamos planos de saúde</p>
                  <p className="text-muted-foreground text-[11px] sm:text-xs leading-relaxed">Nossos atendimentos são exclusivamente particulares. Não trabalhamos com convênios ou planos de saúde.</p>
                </div>
              </div>
              <div className="h-px bg-coral/20" />
              <div className="flex items-start gap-2.5 sm:gap-3">
                <Info className="w-4 h-4 sm:w-5 sm:h-5 text-coral-dark flex-shrink-0 mt-0.5" />
                <div className="space-y-0.5 sm:space-y-1">
                  <p className="font-semibold text-foreground text-xs sm:text-sm">Não realizamos atendimento gratuito</p>
                  <p className="text-muted-foreground text-[11px] sm:text-xs leading-relaxed">Todas as sessões são cobradas conforme os valores informados no momento do agendamento.</p>
                </div>
              </div>
            </div>

            <div className="space-y-2 sm:space-y-3 pt-1 sm:pt-2">
              <p className="text-muted-foreground text-xs sm:text-sm">Ao continuar, você confirma que está ciente destas informações.</p>
              <Button variant="hero" size="lg" className="w-full text-sm sm:text-base py-3 sm:py-4" onClick={handleContinue}>
                Agendar Agora
                <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
              </Button>
            </div>

            <button onClick={close} className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors">
              ← Voltar para a página inicial
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default WarningPopup;
